import { action, observable, runInAction } from 'mobx';
import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderTemplateItemService, ItemSubcategoryService} from "application/facility-order/services";
import { SubCategoryService } from "application/product/services";
import { LookupService } from "common/services";
import _ from 'lodash';
import { uuid } from "core/utils";
import { ModalParams } from 'core/models';
import { subCategoriesSort } from 'core/utils';

class FacilityOrderTemplateNewFlowCreateViewStore extends BaseViewStore {
	@observable accessor itemCategory = "";
    @observable accessor productStore;
    @observable accessor disabledTable = false;

	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;

        this.form = componentsProps.form;
        this.facilityOrderTemplateItems = componentsProps.facilityOrderTemplateItems;
        this.facilityOrderTemplateTrachItems = componentsProps.facilityOrderTemplateTrachItems;

        this.facilityOrderId = componentsProps.facilityOrderId;
        this.patientKey = componentsProps.patientKey;
        this.facilityOrder =componentsProps.facilityOrder;

        this.isMasterPatient = this.patientKey ? (this.facilityOrder && this.facilityOrder.facility.masterPatientId == this.patientKey) : false;

        this.subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategorysAbrv = (this.facilityOrder && this.facilityOrder.isEnteralWeek) && !this.isMasterPatient ? ["G-Tube", "Oral-Supplements", "Enteral"] : ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube","Urologicals", "Ostomy-Products"];
                const response = await this.subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory" });

                let data = subCategoriesSort(response.data.item.map(i => { return { ...i, name: `${i.name}` } }));
                
                let filteredSubCategories = _.filter(data, i => {
                    return subCategorysAbrv.some(s => i.abrv === s);
                });
                return filteredSubCategories;
            },
            onChange: async () => {
                this.setItemCatrgory();
                await this.setProductStore();
                
                if (this.facilityOrderTemplateItems && this.facilityOrderTemplateItems.splice) {
                    this.facilityOrderTemplateItems.splice(0); 
                }

                if (this.facilityOrderTemplateTrachItems && this.facilityOrderTemplateTrachItems.splice) {
                    this.facilityOrderTemplateTrachItems.splice(0);
                }   

                if (this.facilityOrderTemplateItems.length === 0) {
                    this.addEmptyItem(this.facilityOrderTemplateItems);
                }
              
            }
        });

        this.facilityOrderTemplateItemNewFlowCalculationModal = new ModalParams({});
        this.facilityOrderTemplateItemNewFlowNoteModal = new ModalParams({});

        this.fetch([
			this.initialize()
		]);
    }

	@action.bound
	async initialize() {
		await this.getLookups();
        await this.addEmptyItem(this.facilityOrderTemplateItems);
        this.form.clear();
	}

	@action.bound
	async getLookups() {
        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        const response = await lookupService.getLookups("ImportAction,ImportDetailStatus,ItemCategory,SubCategory");
        runInAction(() => {
            this.importActions = response.importAction;
            this.importDetailStatuses = response.importDetailStatus;
            this.itemCategories = response.itemCategory;
            this.subCategories = response.subCategory;
        })
    }

    @action.bound
    async addEmptyItem(facilityOrderTemplateItems) {
        await this.setProductStore();

        facilityOrderTemplateItems.push({
            id: uuid(),
            note: null,
            product: null,
            productId: null,
            procedureCode: null,
            mlph: undefined,
            frequency: undefined,
            itemCals: 0,
            itemMls: 0,
            templateQuantity: 0,
            orderQuantity: 0,
            importAction: this.importActions.find(x => x.abrv == 'insert'),
            importActionId: this.importActions.find(x => x.abrv == 'insert').id,
            importDetailStatusId: this.importDetailStatuses.find(x => x.abrv == 'new').id,
        });
    }

    @action.bound
    async addItem(facilityOrderTemplateItems, items, index) {
        this.disabledTable = true;
        facilityOrderTemplateItems.splice(index);
        _.each(items, i => {
            facilityOrderTemplateItems.push({
                id: uuid(),
                note: i.note,
                product: i.product,
                productId: i.product.id,
                procedureCode: i.procedureCode,
                mlph: i.mlph,
                frequency: i.frequency,
                itemCals: i.itemCals,
                itemMls: i.itemMls,
                templateQuantity: i.templateQuantity,
                orderQuantity: i.orderQuantity,
                importAction: this.importActions.find(x => x.abrv == 'insert'),
                importActionId: this.importActions.find(x => x.abrv == 'insert').id,
                importDetailStatusId: this.importDetailStatuses.find(x => x.abrv == 'new').id,
            });
        });
        this.addEmptyItem(facilityOrderTemplateItems);
        this.disabledTable = false;
    }

    @action.bound
    async deleteItem(facilityOrderTemplateItems, index) {
        this.disabledTable = true;
        facilityOrderTemplateItems.splice(index, 1);

        if (facilityOrderTemplateItems.length === 0) {
            this.addEmptyItem(facilityOrderTemplateItems);
        }
        this.disabledTable = false;
    }

    @action.bound
    editItem(facilityOrderTemplateItems, index, value, propertyName) {
        this.disabledTable = true;
        facilityOrderTemplateItems[index][propertyName] = value;
        if(propertyName === "templateQuantity"){
            facilityOrderTemplateItems[index]["orderQuantity"] = value;
        }
        this.disabledTable = false;
    }

    @action.bound
    async saveItem(facilityOrderTemplateItems, index, product, isEnteral) {
        this.disabledTable = true;
        if (product) {
            let tempItem = {
                product: product,
                productId: product.id,
                procedureCode: product.procedureCode_ && product.procedureCode_.abrv
            };

            const itemType = (product.itemType && (product.itemType.abrv === 'bottle' || product.itemType.abrv === 'can')) || (product.procedureCode_ && product.procedureCode_.abrv === 'B4155')
            if (!this.isMasterPatient && isEnteral && itemType) {
                _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
            }

            const facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(this.rootStore.application.baasic.apiClient);
            try {
                const response = await facilityOrderTemplateItemService.createAdditionalItemsNewFlow(
                    {
                        facilityOrderId: this.facilityOrderId,
                        facilityOrderItem: tempItem,
                        facilityOrderItems: this.facilityOrderTemplateItems.filter(i => i.product).map(i => { return { product: i.product, productId: i.productId, procedureCode: i.procedureCode } }),
                        subCategoryId: this.subCategoryStore.value && this.subCategoryStore.value.id,
                        isMasterPatient: this.isMasterPatient
                    });

                if (!this.isMasterPatient && tempItem.product.innerCannulaId && facilityOrderTemplateItems != this.facilityOrderTemplateTrachItems) {
                    const responseTrach = await facilityOrderTemplateItemService.createAdditionalTrachItemsNewFlow(
                        {
                            facilityOrderId: this.facilityOrderId,
                            facilityOrderItem: tempItem,
                            subCategoryId: this.subCategoryStore.value && this.subCategoryStore.value.id,
                        });
                    this.addItem(this.facilityOrderTemplateTrachItems, responseTrach, index);
                }
                this.addItem(facilityOrderTemplateItems, response, index);

                if(!this.isMasterPatient && isEnteral && itemType){
                    index = facilityOrderTemplateItems.indexOf(facilityOrderTemplateItems.slice(index).find(i=> i.productId == tempItem.productId));
                    this.openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index);
                }
            }
            catch (err) {
                this.rootStore.notificationStore.error(err.data ? err.data : "FACILITY_ORDER_TEMPLATE_ITEM.EDIT.ERROR");
            }
        }
        this.disabledTable = false;
    }

    @action.bound
    async setProductStore() {
        const ostomySubCategory = this.subCategories.find(x => x.abrv == 'Ostomy-Products');
        const isOstomySubCategory = this.subCategoryStore.value && this.subCategoryStore.value.id === ostomySubCategory.id;

        this.productStore = new BaasicDropdownStore({
            filterable: true,
            textField: "itemId",
        }, {
            fetchFunc: async (term) => {
                if(!this.subCategoryStore.value)
                    return [];

                let params = {
                    searchQuery: term,
                    rpp: 50,
                    subCategoryId: this.subCategoryStore.value.id,
                    isActive: true,
                    embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_"
                }

                if (isOstomySubCategory) {
                    params = {...params, sort: "isPreferred|desc"};
                }

                const response  = await this.itemSubcategoryService.find(params);
                let filteredProducts = this.isMasterPatient ? response.data.item : response.data.item.filter(x=> !x.product.itemId.toLowerCase().includes("-cs"));

                return _.map(filteredProducts, item => {
                    return {
                        ...item.product              
                    };
                });
            }
        });
    }   

    @action.bound
    setItemCatrgory() {
        const oldItemCategory = this.itemCategory;
        this.itemCategory = this.subCategoryStore.value && this.subCategoryStore.value.itemCategory && this.subCategoryStore.value.itemCategory.abrv;

        if (oldItemCategory === 'enteral' && oldItemCategory !== this.itemCategory) {
            _.each(this.facilityOrderTemplateItems, item => {
                item.mlph = undefined;
                item.frequency = undefined;
                item.itemCals = 0;
                item.itemMls = 0;
            });
        }
    }

	@action.bound
	openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplateItems, index) {
        this.facilityOrderTemplateItemNewFlowCalculationModal.open({
            facilityOrderTemplateItem: facilityOrderTemplateItems[index],
            facilityOrderId: this.facilityOrderId
        });
    }

    @action.bound
    openFacilityOrderTemplateItemNewFlowNoteModal(facilityOrderTemplateItems, index) {
        this.facilityOrderTemplateItemNewFlowNoteModal.open({
            facilityOrderTemplateItem: facilityOrderTemplateItems[index]
        });

    }
}

export default FacilityOrderTemplateNewFlowCreateViewStore;